import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { GiLotus } from "react-icons/gi";
import { useNavigate } from "react-router-dom";

const Guidelines = () => {
  const navigate = useNavigate();
  return (
    <div className="font-jost mt-20 min-h-screen bg-gradient-to-br from-yellow-100 via-white to-yellow-100 p-6 md:p-12">
      <button
        onClick={() => navigate(-1)}
        className="hover:bg-grey-200 mb-4 flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-medium shadow-md transition"
      >
        <FaArrowLeft className="h-4 w-4" />
        Back
      </button>
      <div className="mx-auto max-w-5xl rounded-3xl bg-white/90 p-6 shadow-2xl backdrop-blur-sm md:p-12">
        {/* Title */}
        <div className="mb-8 text-center">
          {/* <div className="flex justify-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#FBCC17] shadow-md">
              <GiLotus className="animate-pulse text-5xl text-white" />
            </div>
          </div> */}
          <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-gray-800 md:text-4xl">
            Choosing a Marriage Partner
          </h1>
          <p className="mt-2 text-gray-500">Guidance & Blessings</p>
        </div>

        {/* Letter Content */}
        <div className="prose prose-lg max-w-none text-gray-700">
          <p className="italic">My dear disciples,</p>
          <p>Please accept my blessings. All glories to Srila Prabhupada.</p>

          <p className="mb-3">
            When you are trying to find a prospective spouse there are four
            things to consider:
          </p>

          <ol className="list-decimal space-y-1 rounded-lg bg-[#FBCC17]/30 pb-2 pl-8 pr-2 pt-2 shadow-inner">
            <li>Whom to Look for</li>
            <li>Where to Look for</li>
            <li>How to Look for</li>
            <li>What to Look for</li>
          </ol>

          <p className="mt-4 font-medium text-gray-800">
            The sequence of the above steps is of the essence. You cannot mix
            and match the steps. They are in a specific sequence.
          </p>

          {/* Sections */}
          <div className="mt-8 space-y-8">
            <section>
              <h2 className="mb-2 text-xl font-bold text-[#FBCC17]">
                1) Whom to look for
              </h2>
              <p>
                I have instructed my disciples over the years that they should
                look only among ISKCON devotees for a prospective spouse.
                Otherwise I have seen that the prospective spouse maybe
                favorable to your Krishna Consciousness before marriage but
                after marriage everything changes and marriage which was meant
                to help you in your Krishna Consciousness would become filled
                with difficulties. I am sure that you do not want that in your
                marriage. I can give you many examples of that. Suffice it to
                say that one of my male disciples got married to a lady, a
                non-devotee who was favorable to Krishna Consciousness but after
                they had a child, she began to feed the child non-vegetarian
                food. What can be done in these situations? So please be careful
                to avoid getting entangled like that.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-xl font-bold text-[#FBCC17]">
                2) Where to look for
              </h2>
              <p>
                My office in Mayapur offers a matrimonial service called VMB
                (Vaisnava Marraige Bureau). You can register with them and they
                can help you shortlist some profiles. There are also other
                devotee websites which you may wish to look at. However I would
                like to add a word of caution that when you look at a profile on
                these websites, please check if the profile also contains a
                reference to some senior devotee of ISKCON so that you can
                verify with them whether the candidate is a devotee in good
                standing or not. Else you would be pursing the proposal at your
                own risk.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-xl font-bold text-[#FBCC17]">
                3) How to look for
              </h2>
              <p>
                Once you have received some profiles from my office and/or found
                some suitable profiles from devotee websites, please decide
                which profile you would like to proceed with. It is not
                recommended that you proceed with all profiles simultaneously.
                You should proceed with only one proposal at a time. Please
                note: The more your requirements are in your profile, the harder
                it gets to find a suitable match. So it would be always useful
                to seek the help and advice of senior, experienced grhasthas who
                can tell you what the essentials really are and help you out.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-xl font-bold text-[#FBCC17]">
                4) What to look for
              </h2>
              <div className="space-y-4">
                <p>
                  Once you have decided which profile you would like to proceed
                  with, the next is to check for astrological compatibility. I
                  wish to inform you in this regard that Prahladananda Maharaja
                  who has studied and has experience of over 20 years in
                  astrology told me that he has observed that astrology
                  contributes to only 20% of the success of a Krishna Conscious
                  marriage. The other 80% involves devotional inclinations,
                  service attitude, seriousness in taking up the mission of
                  Srila Prabhupada etc. So even if the astrological check does
                  not throw up a favorable result, you can still exchange
                  expectations(which I have outlined a little later in this
                  approach) and check what areas are unfavorable and how they
                  can be handled/mitigated so that they do not become an
                  obstacle in Krishna Consciousness. The general guidelines in
                  this regard about how to handle/mitigate astrological
                  incompatibility can be given by senior experienced grhasthas
                  whom you may wish to consult. If the incompatibility is too
                  serious like for example if it says that there is chance of
                  death of one of the partners etc, then you may decide to drop
                  it if you wish to.
                </p>
                <p>
                  When you are past the astrological compatibility check, the
                  next step is to check whether the spiritual master of the
                  prospective spouse if it happens to be someone else than me,
                  would be willing to accept you as his siksa disciple.
                  Similarly the prospective spouse with the permission of
                  his/her spiritual master can write to me requesting to become
                  a siksa disciple. Like this if both the partners are accepted
                  by each others respective spiritual masters as siksa
                  disciples, then it is favorable for a smooth situation
                  post-marriage. HH Radhanatha Maharaja and HH Gopal Krishna
                  Maharaja have given their pre-approval to accept my disciples
                  are their siksa disciples in such marriage combinations.
                  Likewise their disciples also have my pre-approval to be
                  accepted as my siksa disciples.
                </p>
                <p>
                  After these two steps are done, the next step is to exchange
                  expectations. The VMB has a marriage questionnaire which you
                  can use. Do not try to meet up with the prospective spouse
                  first or start communicating through phone, What's App etc
                  without exchanging expectations. What normally happens when
                  prospective devotee partners try to meet up first or start
                  communicating with each other is that their harmones overpower
                  them clouding objective assessment about each other. So please
                  do not try to meet up with your prospective spouse or start
                  communicating without exchanging expectations.
                </p>
                <p>
                  Once you exchange expectations, it would be helpful if you
                  have senior experienced grhasthas to help you to process both
                  your answers. Sometimes some expectations may be unrealistic
                  or some of the expectations may change. I have one male
                  disciple who told his prospective wife that when children are
                  born, she should handle the children and that he would not
                  carry them around. But after he was married and he had a
                  child, I saw that he was happily carrying the child around.
                  Like this, some expectations may change. Senior experienced
                  grhasthas can tell. They can also see others things through
                  their experience which you may not be able to see. So in this
                  way their wisdom would be useful for both partners while
                  processing answers to the questionnaire.
                </p>
                <p>
                  After you are satisfied with the answers, you can meet up with
                  the prospective spouse and thereafter decide if this proposal
                  should end in marriage or not. Again at this stage the wisdom
                  of the senior experienced grhasthas may come in useful for you
                  to make your decision.
                </p>
              </div>
            </section>
          </div>

          {/* Closing paragraphs */}
          <div className="mt-10 space-y-4 border-t border-[#FBCC17] pt-6">
            <p>
              Hope that you are able to find a suitable Krishna Conscious
              spouse. You have all my blessings in this regard.
            </p>
            <p>
              Sometimes disciples think that I would personally choose a spouse
              for them. As a Sannayasi, Srila Prabhupada instructed me not to
              get involved in marriage matters. So I do not choose a spouse for
              any of my disciples. My secretaries have told me that some
              disciples think that although I do not choose a spouse for my
              disciples in general, I would make an exception for them. I am a
              follower of Srila Prabhupada and so why should they think that I
              would disregard what Srila Prabhupada told me and make an
              exception for them? They should give up such thoughts and instead
              of delaying their efforts to get married by such unreasonable
              imaginations, they should adopt the steps that I have outlined
              above.
            </p>
            <p>
              Some times disciples approach me whether I know of any prospective
              spouse for them. Since I travel around the world, I know many
              different devotees and if anybody comes to my mind I may suggest a
              name. However you should not treat such a suggestion as special
              coming from the spiritual master. Neither is it my desire or order
              to finalize your marriage with the prospective spouse suggested by
              me. I am merely passing on information that I know. So treat it
              like that and process the proposal according to the normal process
              that I have outlined above.
            </p>
            <p>
              Sometimes devotees, especially boys after going through the whole
              process finally revisit astrology and drop the proposal. This has
              a very devastating effect on the girl. We should avoid putting
              Vaisnavis into distress. That is why it is very important to
              follow the sequence that I have outlined and not try to sidestep
              it or undo it at a later stage. Ofcourse devotee girls may also
              revisit astrology at a later stage and drop a proposal affecting
              the boy, which is again improper. So please avoid these things.
            </p>
            <p className="mt-6 font-semibold">Your Well Wisher Always,</p>
            <p className="font-bold text-[#FBCC17]">Jayapataka Swami</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guidelines;
